import Vue from "vue"
import { ScrollPicker } from "vue-scroll-picker"
import "vue-scroll-picker/dist/style.css"

Vue.component("ScrollPicker", ScrollPicker)
